import { useCompanyListQuery } from "@/services/backend/company/company-service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { H3 } from "@/shared/components/typography";
import { CompanyProfileCard } from "./_components/company-profile-card";
import { AddressListTable } from "./_components/address-list-table";
import { PutAddressDialog } from "./_components/put-address-dialog";

export function CompaniesRoute() {
  const { data, isLoading, error } = useCompanyListQuery({
    limit: 1,
    offset: 0,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <Skeleton className="h-24 w-full" />;
  }

  const company = data?.items?.[0];

  return (
    <div className="flex flex-col gap-4">
      {company && <H3>Unternehmen</H3>}
      <CompanyProfileCard company={company} />
      {company && (
        <div className="flex flex-col gap-4">
          <div className="flex flex-row items-center justify-between">
            <H3>Adressen</H3>
            <PutAddressDialog companyId={company.id} />
          </div>
          <AddressListTable companyId={company.id} />
        </div>
      )}
    </div>
  );
}
